export default function check(uqn) {
    if (uqn < 30 || uqn > 60) {
        return false;
    }
    let n = Number(uqn.toString()[0]);
    let m = Number(uqn.toString()[1]);
    if ((n + m) > 6) {
        return false;
    }
    return true;
}
